import { createFileRoute } from '@tanstack/react-router'
import MidDetailPage from '@/pages/MidDetailPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/mid/$mid')({
  component: MidDetailPage,
})